export default {
  styleOverrides: {
    root: {
      backgroundColor: 'var(--color-bg-paper)',
      color: 'var(--color-text-primary)',
    },

    outlined: {
      border: '1px solid var(--color-border)',
    },

    elevation1: {
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    },

    elevation2: {
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
    },

    elevation3: {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    },

    elevation4: {
      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.12)',
    },
  },
};
